import Categorypic from "../../components/categorypiker/Categorypic";
import { MeetingQR } from "./Meetingqrcode";
import getMeetingTime from "./utility/getMeetingTime";
import meeticon from "../../assets/meet_icon.png"
import { ChangeColor } from "../../components/ticketscore/changecolor";
const Header = ({ info, onClick }) => {
  return (
    <div 
      className="heaerdmeeting" 
      onClick={onClick}
  
      style={{ cursor: "pointer" , backgroundColor:ChangeColor(info?.stage) }}
    >
      <div style={{ display: "flex", justifyContent:"space-between" , alignItems:"center" }}>
   <div style={{ display: "flex", gap: "10px" }}>

        <div style={{ height: "50px", width: "50px" }}>
          <Categorypic iswidth={true} categoryID={info?.categoryid} />
        </div>

        <div>
          <p className="meetname">{info?.name}</p>
          <div className="meetingtimedetails">
            <span>{getMeetingTime(info?.scheduledtime?.date)}</span> - 
             <span> {getMeetingTime(info?.endtime?.date)}</span>
          </div>

        </div>
      </div>
      <div  style={{display:"flex", gap: info?.meetlink && "15px", justifyContent:"space-between" , alignItems:"center"}}>
       {(info?.meetlink != "-1" && info?.gmeetenabled !== "0" &&
  (info?.stage == "0" || info?.stage == "1")) && (
  <div
    onClick={(e) => {
      e.stopPropagation();
      window.open(info?.meetlink, "_blank"); 
    }}
    style={{
      backgroundColor: "white",
      width: "45px",
      height: "45px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)" 
    }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src={meeticon}
      alt="Meeting Icon"
      style={{ width: "35px", height: "35px" }}
    />
  </div>
)}
 {
  (info?.stage == 1 && info?.meetingqr != -1 && info.joined == 1)  && (
    <div
      onClick={(e) => e.stopPropagation()}  
    >
      <MeetingQR meetingCode={info.meetingqr} />
    </div>
  )
}
      </div>
  
      </div>
   
    </div>
  );
};

export default Header;